<template>
  <v-progress-circular v-if="loading" indeterminate :color="color"></v-progress-circular>
  <v-icon v-else>{{icon}}</v-icon>
</template>

<script>
export default {
  name: "LoadingIcon",
  props: {
    loading: Boolean,
    color: String,
    icon: String
  },
  data: () => {
    return {};
  }
};
</script>